import { Component, EventEmitter, Input, Output, HostListener, ElementRef } from '@angular/core';
import { NavItemOptions } from '../../../core/models/nav-item-options';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-nav-item-options',
  standalone: false,
  templateUrl: './nav-item-options.component.html',
  styleUrl: './nav-item-options.component.scss'
})
export class NavItemOptionsComponent {
  @Input() public navItemOptions!: NavItemOptions;
  @Output() public action = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.close();
    }
  }

  launchAction(action: string){
    switch (action){
      case 'PREVIEW':
      case 'DOWNLOAD':
      case 'DELETE':
      case 'EDIT':
      case 'OPEN':
      case 'ROLE_MANAGER':
      case 'KNOWLEDGE_MANAGEMENT':
      case 'MOVE':
      case 'RENAME':
        this.action.emit(action);
        break;
      default:
        console.log('default');
        break;
    }
  }
  close(){
    this.action.emit('CLOSE');
  }

}
